import { render, staticRenderFns } from "./ProfileViewStudentTimelineCard.vue?vue&type=template&id=735e2dd2&"
import script from "./ProfileViewStudentTimelineCard.vue?vue&type=script&lang=js&"
export * from "./ProfileViewStudentTimelineCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports